import React from 'react';
import PropTypes from 'prop-types';

// CPU, memoria e disco da VPS do AFV (comando "recursos" do porteiro)
function tamanho(bytes) {
  if (!bytes) return '0';
  const gb = bytes / 1024 ** 3;
  return gb >= 1 ? `${gb.toFixed(1)} GB` : `${Math.round(bytes / 1024 ** 2)} MB`;
}

function cor(percentual) {
  if (percentual >= 90) return '#dc3545';
  if (percentual >= 75) return '#fd7e14';
  return '#28a745';
}

function Cartao({ titulo, percentual, detalhe, extra }) {
  const semValor = percentual === null;
  return (
    <div className="p-col-12 p-md-4">
      <div
        style={{ border: '1px solid #dee2e6', borderRadius: 6, padding: 10, height: '100%' }}
      >
        <div style={{ display: 'flex', justifyContent: 'space-between', fontWeight: 600 }}>
          <span>{titulo}</span>
          <span style={{ color: semValor ? '#6c757d' : cor(percentual) }}>
            {semValor ? '...' : `${percentual}%`}
          </span>
        </div>
        <div style={{ background: '#e9ecef', borderRadius: 4, height: 10, margin: '6px 0' }}>
          <div
            style={{
              width: `${semValor ? 0 : Math.min(percentual, 100)}%`,
              background: cor(percentual),
              height: '100%',
              borderRadius: 4,
            }}
          />
        </div>
        <div style={{ fontSize: 12 }}>{detalhe}</div>
        {extra ? <div style={{ fontSize: 12, color: '#6c757d' }}>{extra}</div> : null}
      </div>
    </div>
  );
}

Cartao.propTypes = {
  titulo: PropTypes.string.isRequired,
  percentual: PropTypes.number,
  detalhe: PropTypes.string.isRequired,
  extra: PropTypes.string,
};

// recursos: undefined = carregando (os cartoes ja ocupam o lugar, sem pular a tela),
// null = falhou
function PainelRecursos({ recursos }) {
  if (!recursos) {
    const texto = recursos === null ? 'Indisponível no momento' : 'Carregando...';
    return ['CPU', 'Memória', 'Disco'].map(titulo => (
      <Cartao key={titulo} titulo={titulo} percentual={null} detalhe={texto} extra=" " />
    ));
  }
  const { cpu, memoria, disco } = recursos;
  const pctMem = memoria.total
    ? Math.round(((memoria.total - memoria.disponivel) / memoria.total) * 100)
    : 0;
  const pctDisco = disco.total ? Math.round((disco.usado / disco.total) * 100) : 0;
  const qtdContainers = Object.keys(recursos.containers).length;

  return (
    <>
      <Cartao
        titulo={`CPU (${cpu.nucleos} núcleos)`}
        percentual={cpu.uso}
        detalhe={`Carga média 1/5/15 min: ${cpu.carga.join(' / ')}`}
        extra={`${qtdContainers} containers do AFV rodando`}
      />
      <Cartao
        titulo="Memória"
        percentual={pctMem}
        detalhe={`${tamanho(memoria.total - memoria.disponivel)} em uso de ${tamanho(
          memoria.total
        )} (livre ${tamanho(memoria.disponivel)})`}
        extra={
          memoria.swapTotal
            ? `Swap: ${tamanho(memoria.swapUsada)} de ${tamanho(memoria.swapTotal)}`
            : 'Sem swap'
        }
      />
      <Cartao
        titulo="Disco"
        percentual={pctDisco}
        detalhe={`${tamanho(disco.usado)} de ${tamanho(disco.total)} (livre ${tamanho(
          disco.livre
        )})`}
        extra={`Bancos do AFV: ${tamanho(recursos.bancosTamanho)} | backups: ${tamanho(
          recursos.backupsTamanho
        )}`}
      />
    </>
  );
}

PainelRecursos.propTypes = {
  recursos: PropTypes.object,
};

export default PainelRecursos;
